"use client";

import Countdown from '@/app/ui/utils/CountDown';
import { mergeAttributes, NodeViewProps, NodeViewWrapper, ReactNodeViewRenderer } from '@tiptap/react';
import { CountDownEditor_server } from './CountDown_server';

export const CountDownEditor_client = CountDownEditor_server.extend({
    renderHTML({ HTMLAttributes }) {
        return ['CountDown', mergeAttributes(HTMLAttributes)];
    },
    addNodeView() { return ReactNodeViewRenderer(CountDown_editor_component, { "contentDOMElementTag": "article" }) },
});


function CountDown_editor_component(props: NodeViewProps) {
    return <NodeViewWrapper data-drag-handle >
        <Countdown date={ new Date(props.node.attrs.date) } classList='text-2xl my-4' />
    </NodeViewWrapper>
}
/** render logic in client only extent to prevent breaking the nextjs SSR */